<template>
  <div>
    <TickCp v-if="$store.state.renderComponentTicket" :PropsCustomer="PropsCustomer" :FromCustomer="FromCustomer"></TickCp>
  </div>
</template>

<script>
import TickCp from './TickCp.vue'
export default {
  components: { TickCp },
  props: ['PropsCustomer', 'FromCustomer'],
}
</script>

<style scoped></style>
